import { useQuery } from '@tanstack/react-query';

import { useApiClient } from '@/shared/api';
import type {
  InternalApiSystem,
  OpenApiDocument,
} from '@/shared/api-workspace/apiWorkspace.types';

// ky prefixUrl(VITE_API_URL) 기준이라 leading slash 없이 전달.
const INTERNAL_APIS = 'api/v1/internal-apis';

/**
 * GET /api/v1/internal-apis — 사내 시스템 목록.
 * 사내 API 포털과 API 키 발급 모달(사내 API 선택지)이 함께 쓴다.
 */
export const useInternalApiSystemsQuery = () => {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['internal-apis'],
    queryFn: () => apiClient.get<InternalApiSystem[]>(INTERNAL_APIS),
    staleTime: 10 * 60 * 1000,
  });
};

/**
 * GET /api/v1/internal-apis/{code}/openapi — 원본 시스템의 OpenAPI 문서.
 * 게이트웨이가 중계하는 경로만 남아 있다. 백엔드가 10분 캐시하므로 프론트도 같은 주기로 둔다.
 */
export const useInternalApiDocumentQuery = (code: string | null) => {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['internal-apis', code, 'openapi'],
    queryFn: () =>
      apiClient.get<OpenApiDocument>(`${INTERNAL_APIS}/${code}/openapi`),
    enabled: Boolean(code),
    staleTime: 10 * 60 * 1000,
  });
};
